// 文本框与提交按钮控制

export const updateTextarea = ({ container, text, inputLimit }) => {
    if (!container) return;
    const textarea = container.querySelector('#feedback-textarea');
    if (textarea) {
        textarea.value = text;
        if (inputLimit) {
            textarea.maxLength = inputLimit;
        }
    }
    updateCharCounter({ container, text, inputLimit });
};

export const updateSubmitButton = ({ container, text, isSubmitting, isSimpleSubmitBtn, t }) => {
    if (!container) return;
    const submitBtn = container.querySelector('.submit-btn');
    if (submitBtn) {
        submitBtn.disabled = !text.trim() || isSubmitting;
        if (isSubmitting) {
            submitBtn.innerHTML = '<span class="loading-spinner"></span>';
        } else if (isSimpleSubmitBtn) {
            submitBtn.textContent = '';
        } else {
            // 使用翻译函数，如果没有提供则使用默认值
            submitBtn.textContent = t ? t('submit_button') : 'Submit';
        }
    }
};

export const updateCharCounter = ({ container, text = '', inputLimit }) => {
    if (!container) return;
    const counter = container.querySelector('.textarea-counter');
    if (counter) {
        counter.textContent = `${text.length}/${inputLimit || text.length}`;
    }
};

export const bindTextarea = ({ container, onInput, onEnterSubmit }) => {
    if (!container) return;
    const textarea = container.querySelector('#feedback-textarea');
    if (!textarea) return;

    textarea.addEventListener('input', (e) => {
        onInput?.(e.target.value);
    });

    textarea.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
            if (e.altKey) return;
            e.preventDefault();
            onEnterSubmit?.();
        }
    });
};


